import React from 'react'
import { Fade } from '@material-ui/core'

const FadeTransition = ({ children, location, title, ...props }) => {
  return (
    <Fade key={title} timeout={1500} in={true}>
      <main {...props}>{children}</main>
    </Fade>
  )
}

export default FadeTransition
